import { useAppUiStore, } from '@/assets/js/src/pinia/appUi.js'
import { REPORT_TYPES, TYPE_BUG, } from '@/assets/js/src/modules/report/_pinia/_constants.js'
const Home = () => import(/* webpackChunkName: "Home" */ '@/assets/js/src/modules/home/_views/Home.vue')

export default function (pinia) {
    let appUiStore = useAppUiStore(pinia)
    
    return [
        {
            name: 'OpenReport',
            path: '/report/:type',
            component: Home,
            beforeEnter: (to, from, next) => {
                let type = to.params.type
                if(!Object.keys(REPORT_TYPES).includes(type)) {
                    type = TYPE_BUG
                }

                appUiStore.menu = false
                appUiStore.report = true
                appUiStore.reportType = type
                if(typeof from.name === 'undefined') {
                    next()
                    
                    return
                }

                next(false)
            },
        },
    ]
}
